/**
 电站运行看板-故障
 */

import React, { Component } from "react";
import { Tabs, Table } from "antd";
import PropTypes from "prop-types";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
const TabPane = Tabs.TabPane;
@connect((state) => state)
class FaultChart extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      columns1:[
        {
          title: '排名',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '故障名称',
          dataIndex: 'faultName',
          key: 'faultName',
        },
        {
          title: '故障率',
          dataIndex: 'faultRate',
          key: 'faultRate',
        }
      ],
      columns2: [
        {
          title: '排名',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '场站名称',
          dataIndex: 'stationName',
          key: 'stationName',
        },
        {
          title: '故障率',
          dataIndex: 'faultRate',
          key: 'faultRate',
        }
      ],
      columns3: [
        {
          title: '排名',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '物料名称',
          dataIndex: 'materialName',
          key: 'materialName',
        },
        {
          title: '投入数量',
          dataIndex: 'chargedQuantity',
          key: 'chargedQuantity',
        }
      ]      
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    const content = (
      <div className="page-panel">
        <div className="display-board">
          <div className="item">
            <div className="inner" style={{ height: "421px" }}>
              <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                故障类型TOP20排名
              </div>
              <div style={{ flex: 1 }}>
                <Table style={{ minHeight: "340px", height: "340px", overflowY: "auto" }} dataSource={this.props.dataSource1} columns={this.state.columns1}  pagination={false} />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="inner" style={{ height: "421px" }}>
              <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                故障场站TOP20排名
              </div>
              <div style={{ flex: 1 }}>
                <Table style={{ minHeight: "340px", height: "340px", overflowY: "auto" }} dataSource={this.props.dataSource2} columns={this.state.columns2}  pagination={false} />
              </div>
            </div>
          </div>
        </div>
        <div className="display-board">
          <div className="item">
            <div className="inner" style={{ height: "500px" }}>
              <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                投入物料TOP10排名
              </div>
              <div style={{ flex: 1 }}>
                <Tabs defaultActiveKey="1" destroyInactiveTabPane={true}>
                  <TabPane tab="全部物料" key="1">
                    <Table style={{ minHeight: "340px", height: "340px", overflowY: "auto" }} dataSource={this.props.dataSource3} columns={this.state.columns3}  pagination={false} />
                  </TabPane>
                  <TabPane tab="免费物料" key="2">
                    <Table style={{ minHeight: "340px", height: "340px", overflowY: "auto" }} dataSource={this.props.dataSource4} columns={this.state.columns3}  pagination={false} />
                  </TabPane>
                  <TabPane tab="收费物料" key="3">
                    <Table style={{ minHeight: "340px", height: "340px", overflowY: "auto" }} dataSource={this.props.dataSource5} columns={this.state.columns3}  pagination={false} />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(FaultChart);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/faultChart.js